const dataListHotel = (state) => state.dataListHotel

const services = (state) => state.services

const isInventoryList = (state) => state.isInventoryList

export default {
  dataListHotel,
  isInventoryList,
  services
}
